import { type FunctionComponent } from 'react';

import AppLogo from './AppLogos/AppLogo';
import Header from './Header/Header';
import {
  getInitialAvatarURLFromName,
  isDefaultAvatar,
} from '../../../../definitions/avatar';
import { useToken } from '../../../Flow/ConsentContextProvider';

const Headline: FunctionComponent = () => {
  const { clientLogoUrl, clientName } = useToken();
  return (
    <>
      <AppLogo logoUrl={getAvatarUrl(clientLogoUrl, clientName ?? '')} />
      <Header appName={clientName ?? ''} />
    </>
  );
};

function getAvatarUrl(url: string | undefined, name: string): string {
  if (url == undefined || isDefaultAvatar(url)) {
    return getInitialAvatarURLFromName(name);
  }
  return url;
}

export default Headline;
